import { authApi } from '@/lib/api';
import { useAuthStore } from '@/stores/authStore';

let bootstrapDone = false;
let bootstrapPromise: Promise<boolean> | null = null;

export function resetAuthBootstrap(): void {
  bootstrapDone = false;
  bootstrapPromise = null;
}

export function bootstrapAuthSession(): Promise<boolean> {
  if (bootstrapDone) {
    return Promise.resolve(useAuthStore.getState().isAuthenticated);
  }

  if (!bootstrapPromise) {
    bootstrapPromise = authApi
      .refresh()
      .then((res) => {
        if (res.user) {
          useAuthStore.getState().setUser(res.user);
          useAuthStore.getState().markAuthenticated();
          return true;
        }
        useAuthStore.getState().clearSession();
        return false;
      })
      .catch(() => {
        useAuthStore.getState().clearSession();
        return false;
      })
      .finally(() => {
        bootstrapDone = true;
        bootstrapPromise = null;
      });
  }

  return bootstrapPromise;
}

export function markAuthBootstrapped(): void {
  bootstrapDone = true;
}
